<form class="w-full" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="flex flex-column gap-3 {{ getStyleClass() }}">
    <ng-container *ngFor="let c of formPanelConfigs">
      <eo-table-field-form-panel
        #eoFormPanels
        *ngIf="c.visible"
        [formGroup]="c.getFormGroupFromForm(form)"
        [customFormControls]="customFormControls"
        [config]="c"
      />
    </ng-container>
    @if (isSubmitButtonVisible()) {
    <div [class]="getSubmitButtonDivStyleClass()">
      <p-button
        type="submit"
        [label]="getSubmitButtonLabel()"
        [styleClass]="getSubmitButtonStyleClass()"
        [disabled]="isSubmitButtonDisabled()"
        [loading]="isSubmitButtonLoading()"
        [icon]="getIcon()"
      />
    </div>
    }
  </div>
  <button type="submit" style="display: none"></button>
</form>
